<template>
	<tooltip label="Text" placement="right">
		<input
			name="text"
			:placeholder="$t('Text')"
			v-model="text"
			v-validate="'required'"
			:class="{'form-control': true, 'is-invalid': errors.has('text')}"
			v-autocomplete="autocomplete"
			block-status="off"
			emoji-status="on"
		/>
		<span
			v-if="errors.has('text')"
			class="help is-danger invalid-feedback"
		>{{ $t(errors.first('text')) }}</span>
	</tooltip>
</template>

<script>
	/**
	 * @vuese
	 *
	 * @group General
	 *
	 * Autocomplete textarea
	 */
	export default {
		name: 'AutoComplete',

		data() {
			return {
				text: '',
				/**
				 * @vuese
				 *
				 * Autocomplete configuration
				 *
				 * @type {Object}
				 */
				autocomplete: {
					'@f': {
						mode: 1,
						icon: 'fa-cubes',
						list: ['current_date'],
						short_descroption: 'Functions',
						status: true,
					},
					'@v': {
						icon: 'fa-at',
						short_descroption: 'Variables',
						list: ['sender_id', 'sender_full_name', 'sender_platform', 'sender_username', 'sender_message'],
						status: false,
					},
					'@d': {
						icon: 'fa-database',
						short_descroption: 'Database',
						list: [],
						status: true,
					},
				},
			}
		},
	}
</script>


